const fontFamily = {
  body: 'Open Sans',
  heading: 'Bodoni Moda',
};

export const heading1 = {
  fontWeigth: '400 !important',
  fontFamily: `${fontFamily.heading}, serif !important`,
  fontSize: '6rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '4.8rem !important',
  },

  '@media (max-width: 600px)': {
    fontSize: '3.6rem !important',
  },
};

export const heading1Bold = {
  fontWeigth: '700 !important',
  fontFamily: `${fontFamily.heading}, serif !important`,
  fontSize: '6rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '4.8rem !important',
  },

  '@media (max-width: 600px)': {
    fontSize: '3.6rem !important',
  },
};

export const heading2 = {
  fontWeigth: '400 !important',
  fontFamily: `${fontFamily.heading}, serif !important`,
  fontSize: '4.5rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '3.84rem !important',
  },

  '@media (max-width: 600px)': {
    fontSize: '2.7rem !important',
  },
};

export const heading3 = {
  fontWeigth: '400 !important',
  fontFamily: `${fontFamily.heading}, serif !important`,
  fontSize: '4rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '3.2rem !important',
  },

  '@media (max-width: 600px)': {
    fontSize: '2.4rem !important',
  },
};

export const subtitle1 = {
  fontWeigth: '600 !important',
  fontFamily: `${fontFamily.body}, sans-serif !important`,
  fontSize: '2rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '1.6rem !important',
  },

  '@media (max-width: 600px)': {
    fontSize: '1.2rem !important',
  },
};

export const subtitle2 = {
  fontWeigth: '600 !important',
  fontFamily: `${fontFamily.body}, sans-serif !important`,
  fontSize: '1.5rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '1.2rem !important',
  },
};

export const body1 = {
  fontWeigth: '400 !important',
  fontFamily: `${fontFamily.body}, sans-serif !important`,
  fontSize: '1.4rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '1.2rem !important',
  },
};

export const body2 = {
  fontWeigth: '400 !important',
  fontFamily: `${fontFamily.body}, sans-serif !important`,
  fontSize: '1rem !important',

  '@media (max-width: 1024px)': {
    fontSize: '0.9rem !important',
  },
};

export const caption = {
  fontWeigth: '600 !important',
  fontFamily: `${fontFamily.body}, sans-serif !important`,
  fontSize: '1.25rem !important',
};

export const button = {
  fontWeigth: '700 !important',
  fontFamily: `${fontFamily.body}, sans-serif !important`,
  fontSize: '0.875rem !important',
};
